module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_lif_rin.eba0378a.png";